export interface IpWhitelistRule {
  ip: string;
  description?: string;
  createdDate?: string;
}

export interface IpWhitelistConfig {
  ipWhitelistEnabled: boolean;
  ipWhitelist?: string;
  rules: IpWhitelistRule[];
  clientIp?: string;
}

export interface UserIpWhitelistConfig extends IpWhitelistConfig {
  userId: number;
  email: string;
  name: string;
}
